import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TWebsiteBuilderElementType } from "../../nodes/element/websiteBuilderElement";
import {
  faBars,
  faCircleI,
  faCode,
  faHeading,
  faHorizontalRule,
  faImage,
  faLink,
  faParagraph,
  faRectangle,
  faVideo,
} from "@fortawesome/pro-regular-svg-icons";
import { faListUl } from "@fortawesome/pro-solid-svg-icons";
import { IWebsiteBuilderNodeMetadata } from "../nodeMetadata/websiteBuilderNodeMetadata";

type TWebsiteBuilderElementMetadata = Record<TWebsiteBuilderElementType, IWebsiteBuilderNodeMetadata>;

export function useWebsiteBuilderElementMetadata(): TWebsiteBuilderElementMetadata {
  const { t } = useTranslation();

  const elementMetadata: TWebsiteBuilderElementMetadata = useMemo(() => ({
    "button": { title: t("Button"), icon: faRectangle },
    "divider": { title: t("Divider"), icon: faHorizontalRule },
    "embed": { title: t("Embed"), icon: faCode },
    "heading": { title: t("Heading"), icon: faHeading },
    "icon": { title: t("Icon"), icon: faCircleI },
    "image": { title: t("Image"), icon: faImage },
    "link": { title: t("Link"), icon: faLink },
    "list": { title: t("List"), icon: faListUl },
    "logo": { title: t("Logo"), icon: faImage },
    "navigation-menu": { title: t("Menu"), icon: faBars },
    "paragraph": { title: t("Paragraph"), icon: faParagraph },
    "video": { title: t("Video"), icon: faVideo },
  }), []);

  return elementMetadata;
}